<div class="justup-dialog">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()"
  >
    {{ title() }}
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16">
    <!-- GroupBy toggle + toggle MO -->
    <div class="flex-row justify-center align-center gap-16 wrap">
      <vl-chips-toggle [elements]="groupByElements" [(value)]="groupBy" size="small"/>
      <div class="flex-row gap-6 align-center">
        <mat-slide-toggle
          [checked]="includeMO()"
          (change)="includeMO.set($event.checked)"
          color="primary"/>
        <span class="caption on-background-alt">Inclure la MO</span>
      </div>
    </div>

    <!-- Stats cards -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="valid" icon="euro" [title]="'dashboard_ui.valeur_totale' | trans" style="flex: 1; min-width: 140px">
        <span content class="headline">{{ stats().caFormatted }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" [color]="margeColor()" icon="trending_up" title="Marge" style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ stats().margeFormatted }}</span>
          <span class="tiny" style="opacity: 0.7">{{ stats().tauxMarge | number:'1.1-1' }}%</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" color="secondary" icon="groups" [title]="stats().countLabel | titlecase" style="flex: 1; min-width: 140px">
        <span content class="headline">{{ stats().count }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="warn" icon="leaderboard" [title]="'dashboard_ui.concentration' | trans" style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <div class="flex-row align-baseline gap-4">
            <span class="headline">{{ stats().pareto80Count }}</span>
            <span class="body-2" style="opacity: 0.7">/ {{ stats().count }}</span>
          </div>
          <span class="tiny" style="opacity: 0.7">{{ 'dashboard_ui.concentration_desc' | trans }}</span>
        </div>
      </vl-radio-card>
    </div>

    <!-- Header : indique à quoi correspondent les colonnes de chiffres -->
    <div class="flex-row gap-8 p-8 align-center"
         style="padding-right: 12px; border-bottom: 1px solid var(--color-on-disabled)">
      <span class="shrink-0" style="width: 16px"></span>
      <span class="shrink-0" style="width: 10px"></span>
      <span class="grow tiny on-background-alt"
            style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        {{ stats().countLabel | titlecase }}
      </span>
      <span class="tiny on-background-alt shrink-0"
            matTooltip="Taux de marge = (CA − Coût) / CA"
            style="min-width: 40px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        Marge
      </span>
      <span class="tiny on-background-alt shrink-0"
            matTooltip="Chiffre d'affaires HT sur la période"
            style="min-width: 80px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        CA
      </span>
      <span class="tiny on-background-alt shrink-0"
            matTooltip="Part du CA total de la période"
            style="min-width: 45px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        Part
      </span>
    </div>

    <!-- Detail tree -->
    @for (row of rows(); track row.denomination) {
      <!-- LEVEL 0 : Group -->
      <div>
        <div class="flex-row gap-8 p-8 align-center border-box border-8 cursor-pointer"
             [style.border-left]="getColor(row.denomination) ? '3px solid ' + getColor(row.denomination) : '1px solid var(--color-outline)'"
             style="border: 1px solid var(--color-outline)"
             (click)="toggle(row.denomination)">
          <mat-icon class="on-disabled shrink-0" style="font-size: 16px; width: 16px; height: 16px">
            {{ isOpen(row.denomination) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
          @if (getColor(row.denomination)) {
            <span class="shrink-0 border-full" [style.background-color]="getColor(row.denomination)" style="width: 10px; height: 10px"></span>
          }
          <span class="grow caption on-background-alt" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
            {{ row.denomination }}
          </span>
          <span class="tiny shrink-0" [class]="margeClass(row.tauxMarge)" style="min-width: 40px; text-align: right; font-weight: 600">
            {{ row.tauxMarge | number:'1.0-0' }}%
          </span>
          <span class="tiny on-disabled shrink-0" style="min-width: 80px; text-align: right">{{ row.ca | number:'1.0-0' }} €</span>
          <span class="tiny on-accent shrink-0" style="min-width: 45px; text-align: right">{{ row.percentage }}%</span>
        </div>

        @if (isOpen(row.denomination)) {
          <div class="flex-col gap-1 mt-2 mb-2" style="margin-left: 24px">
            @for (sub of row.subs; track sub.denomination) {
              <!-- LEVEL 1 : Sub-group -->
              <div>
                <div class="flex-row gap-8 p-4 align-center cursor-pointer"
                     (click)="toggle(row.denomination + '::' + sub.denomination); $event.stopPropagation()">
                  <mat-icon class="on-disabled shrink-0" style="font-size: 14px; width: 14px; height: 14px">
                    {{ isOpen(row.denomination + '::' + sub.denomination) ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                  <span class="grow tiny on-background-alt" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                    {{ sub.denomination }}
                  </span>
                  <span class="tiny shrink-0" [class]="margeClass(sub.tauxMarge)" style="min-width: 40px; text-align: right; font-weight: 600">
                    {{ sub.tauxMarge | number:'1.0-0' }}%
                  </span>
                  <span class="tiny on-disabled shrink-0" style="min-width: 80px; text-align: right">{{ sub.ca | number:'1.0-0' }} €</span>
                  <span class="tiny on-accent shrink-0" style="min-width: 45px; text-align: right">{{ sub.percentage }}%</span>
                </div>

                @if (isOpen(row.denomination + '::' + sub.denomination)) {
                  @if (sub.articles?.length) {
                    <!-- LEVEL 2 : Article (sous-niveau intercalé) -->
                    <div class="flex-col gap-1 mt-1 mb-1" style="margin-left: 22px">
                      @for (art of sub.articles; track art.denomination) {
                        @let artKey = row.denomination + '::' + sub.denomination + '::' + art.denomination;
                        <div>
                          <div class="flex-row gap-8 p-2 align-center cursor-pointer"
                               (click)="toggle(artKey); $event.stopPropagation()">
                            <mat-icon class="on-disabled shrink-0" style="font-size: 12px; width: 12px; height: 12px">
                              {{ isOpen(artKey) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                            <span class="grow tiny" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: 500">
                              {{ art.denomination }}
                            </span>
                            <span class="tiny shrink-0" [class]="margeClass(art.tauxMarge)" style="min-width: 40px; text-align: right; font-weight: 600">
                              {{ art.tauxMarge | number:'1.0-0' }}%
                            </span>
                            <span class="tiny on-disabled shrink-0" style="min-width: 80px; text-align: right">{{ art.ca | number:'1.0-0' }} €</span>
                            <span class="tiny on-accent shrink-0" style="min-width: 45px; text-align: right">{{ art.percentage }}%</span>
                          </div>
                          @if (isOpen(artKey) && art.lots.length) {
                            <div class="flex-col gap-2 mt-1 mb-2" style="margin-left: 24px">
                              @for (lot of art.lots; track lot.lotNumero) {
                                <ng-container *ngTemplateOutlet="lotTpl; context: { $implicit: lot }"/>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  } @else if (sub.lots.length) {
                    <!-- LEVEL 2 : Lots directs (3 niveaux) -->
                    <div class="flex-col gap-2 mt-1 mb-2" style="margin-left: 28px">
                      @for (lot of sub.lots; track lot.lotNumero) {
                        <ng-container *ngTemplateOutlet="lotTpl; context: { $implicit: lot }"/>
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Template d'une carte lot (réutilisable depuis les niveaux 2 et 3). -->
<ng-template #lotTpl let-lot>
  <div class="flex-row gap-12 p-8 border-on-disabled border-box border-8">
    <div class="flex-col gap-4 grow" style="min-width: 0">
      @if (lot.lotId) {
        <vl-lot-card [lotId]="lot.lotId" mode="text"/>
      } @else {
        <span class="caption on-background-alt" style="font-weight: 600">{{ lot.lotNumero }}</span>
      }
      <div class="flex-row gap-4 align-baseline">
        <span class="tiny on-disabled" style="min-width: 60px">Vente</span>
        <span class="tiny on-background-alt">{{ lot.quantite | number:'1.0-0' }} {{ lot.uniteVente }} × {{ lot.prixUnitaire | number:'1.2-2' }} €</span>
        <span class="tiny on-disabled">=</span>
        <span class="tiny on-background-alt" style="font-weight: 600">{{ lot.ca | number:'1.0-0' }} €</span>
      </div>
      @if (lot.uniteGestion !== lot.uniteVente || lot.quantiteUG !== lot.quantite) {
        <div class="flex-row gap-4 align-baseline">
          <span class="tiny on-disabled" style="min-width: 60px">Coût</span>
          <span class="tiny on-background-alt">{{ lot.quantiteUG | number:'1.0-0' }} {{ lot.uniteGestion }} × {{ lot.coutUnitaire | number:'1.2-2' }} €</span>
          <span class="tiny on-disabled">=</span>
          <span class="tiny on-background-alt">{{ (includeMO() ? lot.coutMat + lot.coutMO : lot.coutMat) | number:'1.0-0' }} €</span>
          @if (includeMO()) {
            <span class="tiny on-disabled">(mat. {{ lot.coutMat | number:'1.0-0' }} € + mo. {{ lot.coutMO | number:'1.0-0' }} €)</span>
          } @else {
            <span class="tiny on-disabled">(mat. uniquement — MO : {{ lot.coutMO | number:'1.0-0' }} € exclue)</span>
          }
        </div>
      } @else {
        <div class="flex-row gap-4 align-baseline">
          <span class="tiny on-disabled" style="min-width: 60px">Coût</span>
          <span class="tiny on-background-alt">{{ (includeMO() ? lot.coutMat + lot.coutMO : lot.coutMat) | number:'1.0-0' }} €</span>
          @if (includeMO()) {
            <span class="tiny on-disabled">(mat. {{ lot.coutMat | number:'1.0-0' }} € + mo. {{ lot.coutMO | number:'1.0-0' }} €)</span>
          } @else {
            <span class="tiny on-disabled">(mat. uniquement — MO : {{ lot.coutMO | number:'1.0-0' }} € exclue)</span>
          }
        </div>
      }
    </div>
    <div class="flex-col gap-2 shrink-0 align-end justify-center">
      <span class="caption" [class]="margeClass(lot.tauxMarge)" style="font-weight: 700">
        {{ lot.tauxMarge | number:'1.0-0' }}%
      </span>
      <span class="tiny on-disabled">Marge : {{ lot.marge | number:'1.0-0' }} €</span>
    </div>
  </div>
</ng-template>
